<template>
    <!-- Home -->
    <section v-if="section.type === 'root'">
        <div class="swiper-container  home__slider" v-swiper-directive="{element: '.home__slider', options: {loop: true,effect: 'fade'}}">
            <div class="swiper-wrapper">
                <div class="swiper-slide swiper__item" v-for="page in section.collections[0].pages" :key="page.id">
                    <div v-if="page.fields.image && page.fields.image.value && page.fields.image.value[0]" class="swiper__background" :style="{'backgroundImage': 'url('+ fullScreenUrl(page.fields.image.value[0])+ ')'}"></div>
                    <div v-else  class="swiper__background" :style="{'backgroundColor': '#f8f8f8'}"></div>
                    <div class="swiper__title">
                        <h2>{{page.title}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper__pagination">
            <div class="home__slider-pagination swiper-pagination"></div>
            <div class="projekte__link"><a href="#">NEUESTE PROJEKTE</a></div>
        </div>
        <div class="lines delay" data-aos="fade"></div>
    </section><!-- End of Home -->

    <!-- Projekte -->
    <section v-else-if="section.type === 'projects'">
        <div class="projects__wrapper">
            <masonry
                :cols="{default: 3, 1200: 2, 400: 1}"
                :gutter="{default: '30px', 700: '15px'}">
                <div class="project" v-for="(item, index) in section.collections[0].pages" :key="item.id" data-aos="fade-down" :data-aos-delay="(index*15)+ '0'">
                    <router-link :to="{name: 'page', params:{pageSlug: item.slug}}">
                        <img v-if="item.fields.preview_image && item.fields.preview_image.value" :src="'/uploads/'+item.fields.preview_image.value[0]" alt="Projekte Image">
                        <h2>{{item.title}}</h2>
                    </router-link>
                </div>
            </masonry>
            <div class="lines lines--one__line" data-aos="fade"></div>
        </div>
    </section><!-- End of Projekte -->

    <!-- Buro -->
    <section v-else-if="section.type === 'buro'">
        <div class="buro__wrapper">
            <div class="buro__content image-text" v-html="section.content"></div>
            <div class="lines lines--one__line" data-aos="fade"></div>
            <div class="team__wrapper" v-if="section.collections[1] && section.collections[1].pages.length">
                <template v-for="team in section.collections[1].pages">
                    <div class="team__item" :key="team.id">
                        <img :src="thumbnailTeam(team.fields.image.value[0])" alt="">
                        <div class="team__content" v-html="team.content"></div>
                    </div>
                </template>
            </div>
        </div>
    </section><!-- End of Buro -->

    <!-- Search -->
    <section v-else-if="section.type === 'search'">
        <div class="search__wrapper">
            <div class="result__number">
                <h2>{{appConstants.translations[locale].searchResultFor}} "{{this.$route.query.q}}"</h2>
                <h3>{{filteredItems.length}} {{appConstants.translations[locale].resultsFound}}</h3>                
            </div>
            <div class="results">
                <template v-for="page in filteredItems">
                    <div class="page" :key="page.id">
                        <div class="overlay">
                            <router-link v-if="page.fields.preview_image && page.fields.preview_image.value && page.fields.preview_image.value[0]" :to="{name: 'page', params: {sectionSlug: projectsSection.slug, pageSlug: page.slug}}" class="post-inner-landscape overlay-inner" :style="{'backgroundImage': 'url('+ fullScreenUrl(page.fields.preview_image.value[0])+ ')'}">
                                
                            </router-link>
                            <router-link v-else :to="{name: 'page', params: {sectionSlug: projectsSection.slug, pageSlug: page.slug}}" class="post-inner-landscape overlay-inner" :style="{'backgroundColor': '#f8f8f8'}">
                                
                            </router-link>                            
                            <div class="overlay-content">
                                <h2 class="overlay-title">{{page.title}}</h2>
                            </div>           
                        </div>         
                    </div>
                </template>
            </div>
            <div class="lines lines--one__line" data-aos="fade"></div>
        </div>
    </section><!-- End of Buro -->

    <!-- Contact -->
    <section v-else-if="section.type === 'contact'">
        <div class="contact__wrapper">
            <div class="contact__content" v-html="section.content"></div>
            <!-- <div class="contact__form">
                <h2>{{appConstants.translations[locale].writeToUs}}</h2>
                <form @submit.prevent="sentMail">
                    <div class="contact__inputs">
                        <div :class="{'focus': user.name !== ''}">
                            <span>NAME</span>
                            <div class="contact__inputs--bg">
                                <input type="text" name="name" v-model="user.name" v-validate="'required'" required>                                
                            </div>
                            <p v-if="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</p>
                        </div>
                        <div :class="{'focus': user.email !== ''}">
                            <span>EMAIL</span>
                            <div class="contact__inputs--bg">
                                <input type="email" name="email" v-model="user.email" v-validate="'required'" required>
                            </div>
                            <p v-if="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>
                        </div>
                    </div>
                    <div class="contact__textarea" :class="{'focus': user.message !== ''}">
                        <span>{{appConstants.translations[locale].textareaPlaceholder}}</span>
                        <div class="contact__textarea--bg">
                            <textarea name="message"  v-model="user.message" rows="3" v-validate="'required'"></textarea>
                        </div>
                        <p v-if="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</p>
                    </div>
                    <transition name="fade">
                        <p v-if="contactResponseMessage">{{contactResponseMessage}}</p>
                    </transition>                    
                    <button type="submit">{{appConstants.translations[locale].sendBtn}}</button>
                </form>
            </div> -->
            <div class="contact__map">
                <h2>{{appConstants.translations[locale].getDirection}}</h2>
                <map-component></map-component>
            </div>
            <div class="lines lines--one__line" data-aos="fade"></div>            
        </div>
    </section><!-- End of Contact -->
</template>

<script>
    import TweenMax from 'gsap/TweenMax'
    import _find from 'lodash/find'
    import {SwiperDirective} from '../directives/swiper'
    import MapComponent from './map-component'
    import {mapState} from 'vuex'
    export default {
        name: 'SectionComponent',
        directives: {
            SwiperDirective
        },
        components: {
            MapComponent
        },
        watch: {
            $route: function () {
                this.fetchData()
            }
        },                  
        created: function () {
            this.fetchData()
            // this.animations()
            this.$route.query
        },
        data () {
            return {
                section: {},
                locale: this.$route.params.locale,
                contactResponseMessage: '',
                params: {
                    title: '',
                    description: '',
                    descriptionTwitter: '',
                    titleTwitter: '',                
                    descriptionFacebook: '',
                    titleFacebook: '',
                    image: '',
                    imageTwitter: '',
                    imageFacebook: '',
                    linkCanonical: ''
                },
                user: {
                    name: '',
                    email: '',
                    message: ''
                }
            }
        },
        head: {
            title: function () {
                return {
                    inner: this.params.title,
                    separator: ' '
                }
            },
            meta: function () {
                return [
                    { n: 'description', c: this.params.description},
                    { n: 'keywords', c: this.params.keywords},
                    { n: 'twitter:title', c: this.params.titleTwitter},
                    { n: 'twitter:description', c: this.params.descriptionTwitter},
                    { n: 'twitter:image', c: `${url}/uploads/${this.params.imageTwitter}`},
                    { p: 'og:title', c: this.params.titleFacebook },
                    { p: 'og:description', c: this.params.descriptionFacebook},
                    { p: 'og:image', c: `${url}/uploads/${this.params.imageFacebook}`},
                    { p: 'og:url', h: `${url}`}
                ]
            },
            link: function() {
                return [
                    { r: 'canonical', h: this.params.linkCanonical}
                ]
            }
        },
        methods: {
            fetchData () {
                const sections = this.$store.getters.getSections
                const section = _find(sections, {slug: this.$route.params.sectionSlug})
                this.section = section

                this.params = this.formatMeta(this.section)
                this.$nextTick( () => {
                    this.$emit('updateHead')
                })
            },           
			sendEmail: function (e) {
				this.$validator.validateAll().then(result => {
					if (result) {
						axios.post('/api/v2/mail/send', this.user)
							.then(response => {
								this.contactResponseMessage = this.appConstants.translations[this.locale].successMessage
								setTimeout(() => {
									this.contactResponseMessage = ""
									this.user = {}
									this.$validator.reset()
								}, 2500)
							})
							.catch(error => {
								this.contactResponseMessage = this.appConstants.translations[this.locale].errorMessage
							})
					} else {
						// validation failed
						console.log('invalid form')
					}
				}).catch(() => {
					// something went wrong
				});
			},
			animations() {
				this.$nextTick(() => {
					let txt = document.querySelector('.image-text')
					if (txt) {
						let timeL = new TimelineLite, 
							mySplitText = new SplitText(txt, {type:"words,chars"}), 
							chars = mySplitText.chars;

						TweenLite.set(txt, {perspective:500});

						timeL
							.staggerFrom(chars, 0.6, {opacity:0, ease:Back.easeOut}, 0.01, "+=0")
					}
				})
			}                        
        },
        computed: {
            ...mapState([
                'sections'
            ]),
            projectsSection () {
                return _find(this.sections, {type: 'projects'})
            },
            filteredItems() {
                return this.$store.state.projects.filter(page => {
                    return page.content.toLowerCase().indexOf(this.$route.query.q.toLowerCase()) > -1 || page.title.toLowerCase().indexOf(this.$route.query.q.toLowerCase()) > -1
                })
            }             
        }
    }
</script>


